import React, { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageTest: React.FC = () => {
  const { language, translations, setLanguage } = useLanguage();
  
  useEffect(() => {
    // Log the current language
    console.log(`Current language: ${language}`);
    
    // Log some sample translations
    console.log('Sample translations:');
    console.log(`- Logo text: ${translations.header.logoText}`);
    console.log(`- Book text: ${translations.nav.book}`);
    console.log(`- Hero title: ${translations.hero.title}`);
    
    // Test browser storage
    const savedLanguage = localStorage.getItem('language');
    console.log(`Language saved in localStorage: ${savedLanguage || 'none'}`);
  }, [language, translations]);
  
  return (
    <div className="p-6 m-6 bg-light-gray rounded-md shadow-md max-w-2xl mx-auto mt-32">
      <h2 className="text-2xl font-bold mb-4 text-navy">Language Test Component</h2>
      <p className="mb-4">Current language: <strong>{language.toUpperCase()}</strong></p>
      
      <div className="mt-6 flex space-x-4 flex-wrap">
        <button 
          onClick={() => setLanguage('de')}
          className={`px-4 py-2 rounded-md transition-all m-1 ${language === 'de' ? 'bg-coral text-white' : 'bg-navy text-white'}`}
        >
          Deutsch
        </button>
        <button 
          onClick={() => setLanguage('en')}
          className={`px-4 py-2 rounded-md transition-all m-1 ${language === 'en' ? 'bg-coral text-white' : 'bg-navy text-white'}`}
        >
          English
        </button>
        <button 
          onClick={() => setLanguage('es')}
          className={`px-4 py-2 rounded-md transition-all m-1 ${language === 'es' ? 'bg-coral text-white' : 'bg-navy text-white'}`}
        >
          Español
        </button>
        <button 
          onClick={() => setLanguage('ru')}
          className={`px-4 py-2 rounded-md transition-all m-1 ${language === 'ru' ? 'bg-coral text-white' : 'bg-navy text-white'}`}
        >
          Русский
        </button>
      </div>
      
      <div className="mt-8 border-t pt-4">
        <h3 className="font-bold text-lg text-navy mb-2">Sample Translations:</h3>
        <div className="grid grid-cols-1 gap-4">
          <div className="bg-white p-4 rounded shadow-sm">
            <h4 className="font-semibold">Hero Title:</h4>
            <p>{translations.hero.title}</p>
          </div>
          <div className="bg-white p-4 rounded shadow-sm">
            <h4 className="font-semibold">Nav Book:</h4>
            <p>{translations.nav.book}</p>
          </div>
          <div className="bg-white p-4 rounded shadow-sm">
            <h4 className="font-semibold">Approach Title:</h4>
            <p>{translations.approach.title}</p>
          </div>
          <div className="bg-white p-4 rounded shadow-sm">
            <h4 className="font-semibold">CTA Title:</h4>
            <p>{translations.cta.title}</p>
          </div>
        </div>
      </div>
      
      <div className="mt-8 text-sm text-gray-600">
        <p>Note: Check the console for more details about the language state.</p>
        <p>Language preferences are stored in localStorage.</p>
      </div>
    </div>
  );
};

export default LanguageTest; 